import array from './array';
import color from './color';
import errors from './errors';
import image from './image';
import job from './job';
import options from './options';
import remnant from './remnant';

export default {
    array,
    color,
    errors,
    image,
    job,
    options,
    remnant
};